import $ from 'jquery'

import React from 'react'
import { Component } from 'react'

import Zitate from 'cms_plugins/zitat_display/js/components/Zitate'
import { TABS_CHOICES } from "cms_plugins/zitat_display/js/components/Zitat";
import Pagination from "./Pagination";
import MultiSelector from "./MultiSelector";


class ZitateList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tabs: { "Zitat": true }
        }
    }

    render() {
        const { results, onPageChange, loadingPreview, onShowZitat } = this.props;
        const tabs = this.state.tabs;
        return (
            <div>
                <Pagination
                    numPages={results.num_pages}
                    curPage={results.page}
                    onChange={onPageChange}
                />
                {loadingPreview ? (
                    loadingPreview
                ) : 
                (
                    <Zitate zitate={results.list} tabs={tabs} 
                        onShowZitat={onShowZitat}
                    />
                )}
                

                <Pagination
                    numPages={results.num_pages}
                    curPage={results.page}
                    onChange={onPageChange}
                />
            </div>
        );
    }
}

export default ZitateList


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/ZitateList.js